import React from 'react';
import Translate from '../../../components/shared/localization/localize';
import { Activity } from '../../../modules/dialogs/transfer/model';
import * as m from '../../../modules/dialogs/transfer/messages';
import { LogEntry } from '../../../components/shared/historical/logs';
import LogStatus from './LogStatus';
import LogSubtitle from './LogSubtitle';
import LogTitle from './LogTitle';
import LogActions from './LogActions';
import useHistorical from '../../../modules/historical/useHistorical';
import useTxActivityLog from '../../../modules/dialogs/transfer/useTxActivityLog';
import Scrim from '../../../components/shared/scrim';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { TransferStatus, TransferType } from '../../../modules/dialogs/transfer/consts';

interface Props {
  a: Activity;
}

const LogActivity: React.FC<Props> = ({ a }) => {
  const { onAccept, onReject, onCancel, onDetails, responseStatus, isViewedBySender } = useTxActivityLog(a);
  const buttons: JSX.Element[] = [];
  if (a.status === TransferStatus.PENDING && a.type === TransferType.REQUEST) {
    isViewedBySender
      ? buttons.push(
          <KFLButton variant="borderless"  onClick={onReject}>
            <Translate message={m.msgBtnDeny}></Translate>
          </KFLButton>,
          <KFLButton onClick={onAccept}>
            <Translate message={m.msgBtnAccept}></Translate>
          </KFLButton>
        )
      : buttons.push(
          <KFLButton variant="borderless" onClick={onCancel}>
            <Translate message={m.msgBtnCancel}></Translate>
          </KFLButton>
        );
  }

  const log = {
    date: new Date(a.datetime),
    title: <LogTitle a={a} isSender={isViewedBySender} onDetails={onDetails} />,
    subtitle: <LogSubtitle a={a} isSender={isViewedBySender} />,
    actions: <LogActions buttons={buttons} />,
    status: <LogStatus a={a} isSender={isViewedBySender} />,
  };
  return (
    <Scrim isActive={responseStatus.isFetching} label={'processing'} fullHeight>
      <LogEntry {...log} />
    </Scrim>
  );
};

export const Activities: React.FC = () => {
  const { logs } = useHistorical<Activity>();
  return (
    <div className="logs-box">
      {logs.map((a) => (
        <LogActivity key={a.datetime} a={a} />
      ))}
    </div>
  );
};

export default LogActivity;
